import React from 'react';
import { useSelector } from 'react-redux';

import RichTextEditor from '@v2/elements/RichTextEditor';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import { generateImageURL } from '@reducers/blobStorage';
import { selectSelectedNote } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { ODataDocument } from '@v2/components/imageHandling/types/types.d';
import type { GenerateImageURLParams } from '@v2/elements/RichTextEditor/types';

interface OPEditorProps {
  onChange: (value: string) => void;
  setTouched: React.Dispatch<React.SetStateAction<boolean>>;
  readOnly?: boolean;
  previewNote?: ODataDocument;
  rawContent?: string;
}

const OPRichTextEditor: React.FC<OPEditorProps> = (props) => {
  const dispatch = useAppDispatch();
  const activeNote = useSelector(selectSelectedNote);
  const handleGenerateImageURL = async (data: GenerateImageURLParams) => dispatch(generateImageURL(data));

  return (
    <RichTextEditor
      {...props}
      scale={scaleOP}
      font={fontOP}
      activeNote={activeNote}
      generateImageURL={handleGenerateImageURL}
    />
  );
};

export default OPRichTextEditor;
